import language from "../language";
import { clearStorage } from "../utils/storage";

const onLogout = async () => {
  await clearStorage();

  window.location.href = "/";
};

const nonAuthMenus = (lng = "english") => [];

const authMenus = (lng = "english") => {
  const userLoggedIn = JSON.parse(
    sessionStorage.getItem(process.env.REACT_APP_NAME) || {}
  );

  const { verified } = userLoggedIn;
  if (verified) {
    return [
      {
        name: language[lng].settings,
        icon: "settings",
        onPress: () => (window.location.href = "/dashboard/settings"),
      },
      {
        name: language[lng].logout,
        onPress: () => onLogout(),
        icon: "logout",
      },
    ];
  }
  return [
    {
      name: language[lng].logout,
      onPress: () => onLogout(),
      icon: "logout",
    },
  ];
};

export { nonAuthMenus, authMenus };
